module.exports = __webpack_public_path__ + "static/media/hair2.0d2cad35.png";